import React, { FC } from 'react';

import { Button } from '../../../../../../../button';
import { Modal } from '../../../../../../../modal/modal.component';
import { ModalIds } from '../../../../../../../../contexts/modals/modals.types';
import { SuccessProps } from './success.types';
import { Typography } from '../../../../../../../../../../../components';
import styles from './success.module.scss';
import { useTranslation } from 'react-i18next';

/**
 * Success component
 * @description Content for the Success stage modal of UsersManagement Invite flow
 *
 * @author Oleksii Medvediev
 * @param { SuccessProps } props - SuccessProps defined in the './success.component.tsx'
 * @category Components
 */
const Success: FC<SuccessProps> = ({ email, name, onClose }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'management' });

  return (
    <Modal modalId={ModalIds.usersManagementInvite} title={t('modals.usersManagement.invite.success.title')}>
      <div className={styles.wrapper}>
        <Typography.Text variant={'bodyText5'}>
          {t('modals.usersManagement.invite.success.text', { name, email })}
        </Typography.Text>
        <Button type={'button'} variant={'main'} size={'large'} onClick={onClose}>
          <Typography.Text variant={'bodyText2'}>{t('modals.usersManagement.invite.success.continue')}</Typography.Text>
        </Button>
      </div>
    </Modal>
  );
};

export { Success };
